import type { LLTextElement } from '../../types';

export function TextElement({ element }: { element: LLTextElement }) {
  return (
    <p className="text-sm text-muted-foreground whitespace-pre-wrap leading-relaxed">
      {element.text}
    </p>
  );
}
